module.exports = __webpack_public_path__ + "assets/img/download.f815d83e.png";